import { createRoute } from "@tanstack/react-router";
import { HomepagePage } from "pages/app/HomepagePage";

import { rootRoute } from "../rootRoute";

export const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  staticData: { pageName: "Homepage" },
  component: HomepagePage,
});
